module.exports = __webpack_public_path__ + "static/media/inclusion_co_pay.65113549.svg";